import { ForwardIcon } from "@/components/icons/forward-icon";
import IconButton from "@/components/ui/buttons/IconButton";
import { cn } from "@/utils/cn";
import { useIonRouter } from "@ionic/react";

import { memo } from "react";

type NextButtonProps = {
  type: "submit" | "button";
  routerLink?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const NextButton = memo(function NextButton({
  type,
  routerLink,
  disabled,
  onClick,
}: NextButtonProps) {
  const navigation = useIonRouter();

  const onButtonClick = () => {
    if (onClick) {
      onClick();
    }
    if (routerLink) {
      navigation.push(routerLink, "none", "push", { unmount: true }, undefined);
    }
  };
  return (
    <IconButton
      className={cn(
        "flex h-14 w-14 items-center justify-center rounded-full",
        "bg-button-black-default active:bg-button-black-active disabled:bg-button-black-disabled text-white",
        // Add a custom shadow using Tailwind's arbitrary value support
        "shadow-[0px_0px_0px_1px_rgba(255,255,255,0.64)]",
      )}
      type={type}
      disabled={disabled}
      onClick={onButtonClick}
    >
      <ForwardIcon className="stroke-button-white-default" />
    </IconButton>
  );
});

export default NextButton;
